import * as React from 'react';
import { Field, reduxForm } from 'redux-form';
import { connect } from 'react-redux';
import { Link } from 'react-router-dom';
import { RenderField, Validators } from './../../Layout/Form/Fields/_Fields';
import { withTranslation  } from 'react-i18next';
import { compose } from 'redux';

const ResetPasswordForm = props => {
    const { pristine, submitting, t, userStore } = props;
    return (
        <form className="form" onSubmit={props.handleSubmit}>
            {userStore.error.resetErr && <p className="form_field--error form_field--error_msg">{t(`errors:${userStore.error.resetErr.errorSubcode}`)}</p>}
            {userStore.success.resetSuccess && <p className="form_field--success form_field--success_msg">{t('resetPasswordSuccess')}</p>}
            <Field name="email" component={RenderField} type="text" placeholder={t('loginLabel')} label={t('loginLabel')} validate={[Validators.required, Validators.email]} />
            <p>
                {t('accountPresent')} <Link to="/">{t('logIn')}</Link>
            </p>
            <button disabled={submitting || pristine} className="btn btn--blue" type="submit">
                {t('send')}
            </button>
        </form>
    );
};

function mapStateToProps(state: any) {
    return {
        viewManagementStore: state.viewManagementStore,
        userStore: state.userStore
    };
}


export default compose(
    connect(mapStateToProps),
    withTranslation (['forms', 'errors']),
    reduxForm({
        form: 'resetPassword'
    })
)(ResetPasswordForm) as React.ComponentClass<any>



// WEBPACK FOOTER //
// ./src/components/UserSigning/Forms/_ResetPasswordForm.tsx